import { AppointmentFormData } from 'types/appointment';

export const initialValues: AppointmentFormData = {
    title: '',
    description: '',
    scheduledDateTime: '',
    email: '',
    firstName: '',
    lastName: '',
    address: null,
    houseDescription: '',
    phoneNumber: '',
    attachments: [],
};

export const MAX_FILE_SIZE = 5242880;
